import React, { useState, useContext } from "react";
import { SketchPicker } from "react-color";
import CustomTagsInput from "../../../../../../CommonComponents/Tags/CustomTagsInput";
import { networkService } from "../../../../../../config/axios";
import { EditorInfoContext } from "../../../../../../../utis/userInfoContext";
import ClickActionSection from "./ClickActionSection"
// import {handleSubmitBtnState} from "../../../editorHook/useEditorHook"
const TagSection = ({
  tool,
  handleChange,
  totalPages,
  setTool,
  errorState,
  toolType,
  editElement,
  docData,
  handleSubmitBtnState
}) => {
  const { setShowToast } = useContext(EditorInfoContext);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const isHotspotElement =
    toolType === "HotspotToolbox" || editElement?.element_type === 9;
  const isAddImageModal = toolType === 'ImageToolbox' && !editElement?.id;
  const handeAddTags = async (value) => {
    let tagsList = await networkService(`tags.json`, "POST", { name: value });
    if (tagsList?.status === 201) {
      setTool((prevState) => {
        const newTags = prevState.tags
          ? [...prevState.tags, tagsList.data]
          : [tagsList.data];
        return {
          ...prevState,
          tags: newTags,
        };
      });
       handleSubmitBtnState()
    }
  };

  const handleRemoveTags = (value) => {
    setTool((prevTool) => ({
      ...prevTool,
      tags: value,
    }));
    handleSubmitBtnState();
  };

  const handleColorChange = (color) => {
    const rgba = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;
    handleChange({
      target: {
        name: "bg_color",
        value: rgba,
      },
    });
  };

const [inputColor, setInputColor] = useState(tool?.value?.bg_color || 'rgba(255, 255, 255, 1)');
const [isValidColor, setIsValidColor] = useState(true);

const handleTextColorChange = (e) => {
  let value = e.target.value.trim();
  setInputColor(value);

  const rgbaRegex = /^rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})(, ?(0|1|0?\.\d+))?\)$/;
  const hexRegex = /^#?([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

  if (value === "") {
    value = "transparent";
    setIsValidColor(true);
    setInputColor(value);
    handleChange({ target: { name: "bg_color", value } });
    return;
  }

  if (rgbaRegex.test(value) || hexRegex.test(value)) {
    if (hexRegex.test(value) && !value.startsWith("#")) {
      value = `#${value}`;
    }
    setIsValidColor(true);
    handleChange({ target: { name: "bg_color", value } });
  } else {
    setIsValidColor(false);
  }
};



const handleColorPickerChange = (color) => {
  // If the alpha is 0, reset to 1 for better UX
  const alpha = color.rgb.a === 0 ? 1 : color.rgb.a;

  const rgba = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${alpha})`;

  setInputColor(rgba);
  setIsValidColor(true);
  handleChange({ target: { name: 'bg_color', value: rgba } });
};


  return (
    <>
      <div className={`tags-inp row ${isHotspotElement ? "hotspot-tags-row" : ""}`}>
        <div className="col-md-6 p-0 ">
          <div
            className={`${
              isHotspotElement
                ? "d-flex flex-column align-items-start hotspot-tags-container"
                : isAddImageModal
                ? "add-image-modal-tags"
                : "d-flex align-items-start flex-column"
            }`}
          >
            <CustomTagsInput
              tags={tool?.tags || []}
              handleAddTags={handeAddTags}
              handleRemoveTags={handleRemoveTags}
              placeholderText={'Please add a new Tag here'}
              tagsPosition={isHotspotElement ? "above" : "below"}
              wrapperClassName={
                isHotspotElement ? "hotspot-tags-wrapper w-100" : ""
              }
              onShowNotification={(opts) => setShowToast?.(opts)}
            />
          </div>
          {(!tool?.tags || tool?.tags?.length == 0) && (
            <p className="text-danger">{errorState?.tagErr}</p>
          )}
        </div>
        <div className="col-md-6">
          <div className="d-flex align-items-center high-element">
            <input
              type="checkbox"
              name="priority"
              id="priority-checkbox"
              checked={tool?.priority}
              onChange={handleChange}
              className="me-2"
            />
            <label className="img-lab-clr mb-0" htmlFor="priority-checkbox">High Priority Element</label>
          </div>
        </div>
      </div>
      <div className="color-select">
        <div className="d-flex align-items-center justify-content-between">
          {toolType != 'Clone' && <>
            <p>BACKGROUND COLOR:</p>
            <div className="colour-picker-field">

  <div
    style={{
      width: "36px",
      // height: "36px",
      backgroundColor: isValidColor ? inputColor : "#fff",
      border: "1px solid #dfdfdf",
      borderRadius: "5px 0 0 5px",
      borderRight: 'none',
      cursor: "pointer",
    }}
    onClick={() => setDisplayColorPicker(!displayColorPicker)}
  ></div>

  {displayColorPicker && (
    <div className="color-picker-popup" style={{ position: "absolute", zIndex: 10000, marginTop: "5px" }}>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
        onClick={() => setDisplayColorPicker(false)}
      />
      <SketchPicker
        color={inputColor}
        onChangeComplete={handleColorPickerChange}
      />
    </div>
  )}

  <input
    type="text"
    value={inputColor}
    onChange={handleTextColorChange}
    className={`colour-picker-field__item colour-picker-field__item--text ${!isValidColor ? 'invalid-color' : ''}`}
  />
</div>

          </>}
        

          {
                (toolType === 'ImageToolbox' ||
                    toolType === 'HotspotToolbox' ||
                    editElement?.element_type === 4 ||
                    editElement?.element_type === 9) && toolType == 'Clone' &&
                <ClickActionSection
                    totalPages={totalPages}
                    handleChange={handleChange}
                    tool={tool}
                    currentDocId={docData?.doc_id}
                    setTool={setTool}
                    errorState={errorState}
                    pdfId={docData?.id} 
                    toolType={toolType}
                />
            }
        </div>
        {tool?.page == '' ?
          <p className="text-danger text-end">Please add a valid page number </p> :
          tool?.page > totalPages ?
            <p className="text-danger text-end">
              Please enter page from 1 to {totalPages}
            </p> :
            <></>
        } 
            {/* {+tool?.value?.page_link === +tool?.page ?
          <p className="text-danger text-end">Please add a page number other than current page</p> :<></>}
          */}
      </div>
    </>
  );
};
export default TagSection;
